var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.29 17.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,3.89a.33.33,0,0,0-.33-.3H10.29a.33.33,0,0,0,0,.66h1l1.26,12.36H.7L2,4.25H3a.33.33,0,1,0,0-.66H1.66a.33.33,0,0,0-.33.3L0,16.91a.32.32,0,0,0,.09.26.32.32,0,0,0,.24.11H13a.34.34,0,0,0,.33-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.63,3.92a.33.33,0,0,0-.33-.33H5a.33.33,0,0,0,0,.66H8.3A.33.33,0,0,0,8.63,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.32,7.57a.66.66,0,1,0,1-.57V3.12A2.41,2.41,0,0,1,6.64.66,2.4,2.4,0,0,1,9,3.12V7a.69.69,0,0,0-.33.57.67.67,0,1,0,1-.57V3.12A3.06,3.06,0,0,0,6.64,0a3.06,3.06,0,0,0-3,3.12V7A.66.66,0,0,0,3.32,7.57Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.8fbabc4f563bdb60291d3801980677d9.svg";
export { ForwardRef as ReactComponent };